export * from './auth/auth';
export * from './modal/modal';
export * from './fileControl/fileControl';

export const resetApp = payload => ({
  type: 'RESET_APP',
  payload,
});
